export const CALENDAR_LINK = 'https://calendly.com/d/z6x-gcg-qcs/30min?month=2023-06'
export const PAGE_NEWS_COUNT = 6
export const PAGE_GET_COUNT = 3
export const SHARE_URL = 'https://nikita.am'